<template>
  <div>
      <div class="addons-container" style="padding:0px 50px 20px; text-aling:left;">
        <h1 style="color:#666; font-family:'prohibition';">Add-Ons</h1>
              <el-row :gutter="40">
                      <h3 style="font-family:'prohibition'; color:#999;">Select one of the <img style="width:55px;" src="../../../assets/rp-logo.png"> services.</h3>
                      <!-- <h5>You already purchased: <span v-for="plan in selectedPlans" >{{plan.name}}</span></h5> -->
                       <el-col :span="24">
                        <el-card v-show="!plans[0].disabled" @click.native="selectPlan(0)"  class="selectable" shadow="hover"  v-bind:class="{'disabled': plans[0].disabled}">
                         <div v-bind:class="{active: (plans[0].selected==true)}" class="indicator"></div>
                    Basic Healthy Diet Template
                    <p class="expandable" @click.stop="expandBasic">What's included?</p>
                    <p v-show="basicVisible">An easy-to-follow guide for creating your own healthy eating plan. By simply following basic recommendations for meal number, portion size and food choices, your resulting diet will provide you with the nutrients to support your health through eating. <a target="_blank" href="https://renaissanceperiodization.com/shop/healthy-diet-templates/">Learn more here</a>
                      <img style="width:300px; margin:10px auto;" src="../../../assets/before_after3.jpeg"></p>
                    <span class="original-price">ORIGINAL PRICE <div class="strike-through">$79</div></span>
                    <span>$49</span>
                  </el-card>
              <el-card  v-show="!plans[1].disabled" @click.native="selectPlan(1)" class="selectable"  v-bind:class="{'disabled': plans[1].disabled}" shadow="hover">
                    <div v-bind:class="{active: plans[1].selected==true}" class="indicator"></div>
                    Advanced RP Diet Template 
                    <p class="expandable" @click.stop="expandAdvanced">What's included?</p>
                    <p v-show="advancedVisible">This is designed to help you either shed body fat while keeping muscle (the fat-loss-diet) or gain muscle (the muscle gain diet). Both fat-loss and muscle gain diets come with maintenance diets and with clear, unambiguous instructions as to their modifications for your needs. <a target="_blank" href="https://renaissanceperiodization.com/shop/rp-diet-templates/">Learn more here</a>
                      <img style="width:300px; margin:10px auto;" src="../../../assets/before_after2.jpg"></p>
                    <span class="original-price">ORIGINAL PRICE <div class="strike-through">$109</div></span>
                    <span>$79</span>
                  </el-card>
                  <el-card  v-show="!plans[2].disabled" @click.native="selectPlan(2)" class="selectable" shadow="hover"  v-bind:class="{'disabled': plans[1].disabled}">
                    <div v-bind:class="{active: (plans[2].selected==true)}" class="indicator"></div>
                    One-on-One RP Nutrition Coaching & Personalized Plan
                    <p  class="expandable" @click.stop="expandOneOnOne">What's included?</p>
                    <p v-show="oneVisible">
                      <ul>
                     <li>Work one-on-one with an expert coach (typically a PhD caliber coach or a world champion/record holder)</li>
                      <li>Create a customized plan to help you achieve your dieting goals (loose fat or gain muscle) with very little left to chance.</li>
                      <li>Check in 2x per week with your coach</li>
                      <li>Your coach will monitor your weekly progress and make any necessary adjustments to your customized program</li>
                      <li>No restrictions on the volume or frequency of contact between you and your coach.</li>
                      <li>All 10 Weeks.</li>
                      <li><a target="_blank" href="https://renaissanceperiodization.com/shop/diet-plan-3-month/">Learn more here</a></li>
                    </ul>
                    
                    <img style="width:300px; margin:10px auto;" src="../../../assets/before_after1.jpg">



                    </p>
                    <span class="original-price">ORIGINAL PRICE <div class="strike-through">$575</div></span>
                    <span>$500</span>
                  </el-card>
                       </el-col>
                    </el-row>
                    <div class="addon-checkout" v-show="addOnPlans.length">
                      <el-row>
                        <el-col class="order-review" :span="24">
                          <h3>Your Add On Purchase</h3>
                          <p v-for="plan in addOnPlans">{{plan.name}} <span>${{plan.price}}</span></p>
                          <p>Service Fee <span>${{fee}}</span></p>  
                          <p style="border-top:1px solid #EEE; padding-top:10px;"><strong>Total <span>${{total}}</span></strong></p> 
                        </el-col>  
                      </el-row>
                      <div class="card-container">
                        <el-select style="width:100%; margin-bottom:10px;" v-model="form.selectedCard" filterable placeholder="Payment Method">
                          <el-option
                            v-for="card in cards"
                            :key="card.id"
                            :label="card.brand +' ending in   **** **** **** '+card.last4"
                            :value="card.id">
                          </el-option>
                          <el-option
                            key="NEW"
                            label="New Card"
                            value="NEW">
                          </el-option>
                        </el-select>

                      </div>
                      <div v-show="form.selectedCard=='NEW'" class="add-on-payment-container">
                            <div id="card-element"></div>
                            <div id="card-errors" role="alert"></div>
                      </div>
                      <el-button v-show="!savingData" style="margin-top:10px; width:100%;" @click="initCheckout" type="primary">Pay for this plan</el-button>
                       <el-button v-show="savingData" :loading="true" style="margin-top:10px; margin-left:10px; width:100%;" type="primary">Pay for this plan</el-button>
                    </div>
                  
      </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      cards:[],
      total:0,
      stripeCustomerId:null,
      cardObject:null,
      subTotal:0,
      totalSpend:0,
      fee:0,
      cardObject:{},
      fee:null,
      addOnPlans: [],
      defaultVisible: false,
      basicVisible: false,
      advancedVisible:false,
      oneVisible:false,
      total:15,
      plans: [
        {selected:false, price:49, disabled: false, stripeName: 'WZACH18_RP49', name: "RP Basic Nutrition"},
        {selected:false, price:79,disabled: false, stripeName: 'WZACH18_RP79', name: "RP Advanced Nutrition"},
        {selected:false, price:500, disabled: false,stripeName: 'WZACH18_RP500', name: "RP 1 on 1 Coaching"}
      ],
      form: {
        selectedCard: null
      },
      savingData:false,
      userData:{
        firstName:"",
        lastName:"",
        email:"",
        password:"",
        passwordConfirm:""
      },
      currentUser:null,
      msg: 'Welcome to Your Vue.js App'
    };
  },
  mounted:function(){
    var _this = this;
    var user = Parse.User.current();
    if(!user){
       this.$router.push('/login');
       return
    }
    user.fetch()
      .then(function(savedUser){
        _this.currentUser = savedUser;
        if(!savedUser.get('weight')){
           this.$router.push('/dashboard/start');
           return
        }
        if(savedUser.get('selectedPlans')) _this.disablePlans()
        _this.getStripeUser(savedUser.get('stripeId'));
      }).catch(function(err){
        console.log(err);
        alert('There was an error loading this page.')
      })

    _this.$nextTick(function () {
      _this.initStripeElement();
    });
    
  },
  methods:{
    disablePlans: function(){
      var _this = this;

      var selectedPlans =  _this.currentUser.get('selectedPlans') || [];
       console.log(selectedPlans)
       console.log(_this.plans)
      for (var i = 0; i < selectedPlans.length; i++) {
        for (var y = 0; y < _this.plans.length; y++) {
           if(selectedPlans[i]){

            if(selectedPlans[i].price == _this.plans[y].price){
              console.log('FOUND MATCH')
              _this.plans[y].disabled= true;
              console.log(_this.plans[y])
              
            } 
          }
        }
      }
    },
    getStripeUser: function(stripeId){

      var _this = this;
      _this.stripeCustomerId = stripeId;
      Parse.Cloud.run('getStripeCustomer', {"customerId": stripeId})
        .then(function(resp){
          console.log('IT WORKED')
          _this.cards = resp.sources.data;
          console.log(resp);
        })
        .catch(function(err){
          console.log(err);
        })
    },
    initCheckout:function(){
      var _this = this;
      if(!_this.form.selectedCard){
        var displayError = document.getElementById('card-errors');  
        displayError.textContent = "Please select a payment method.";
        return 
      }
      _this.savingData = true;
      if(_this.form.selectedCard=='NEW') {
        stripe.createToken(_this.cardObject).then(function(result) {
          if (result.error) {
            _this.savingData = false;
            // Inform the customer that there was an error.
            var errorElement = document.getElementById('card-errors');
            errorElement.textContent = result.error.message;
          } else {
            console.log(result)
            // Send the token to your server.
            Parse.Cloud.run('addCard', {customerId: _this.stripeCustomerId, cardId: result.token.id})
              .then(function(resp){
                console.log(resp)
                 _this.makeAddOnPurchase(result.token.card.id);
              }).catch(function(err){
                _this.savingData = false;
                alert('Error updating user.')
                console.log(err);
              })
            

          }
        });
        //Tokenize card.
      } else {
        //Buy Add On
        _this.makeAddOnPurchase(_this.form.selectedCard);
      }
    },
    makeAddOnPurchase:function(source){
      var _this = this;
      Parse.Cloud.run('addOnPayment', {'source':source, 'product':_this.addOnPlans[0]})
        .then(function(madePurchase){
            _this.savingData = false;
            _this.$message({
                type: 'success',
                message: 'Your plan was added and your template is on the way!'
              });
              _this.addOnPlans = [];
            
        })
        .catch(function(err){
          console.log(err);
          _this.savingData = false;
          alert('There wan error with the card.')
        })
    },
    initStripeElement:function(){

      var elements = stripe.elements();
      // Custom styling can be passed to options when creating an Element.
        var style = {
          base: {
            fontSize: '14px',
            color: "#666"
          }
        };

        // Create an instance of the card Element.
        var card = elements.create('card', {style: style});

        // Add an instance of the card Element into the `card-element` <div>.
        card.mount('#card-element');
          var user = Parse.User.current();
          if(!user){
            this.$router.push('/login');
            return;
          }
          this.selectedPlans = this.addOnPlans;
          this.subTotal = 0;
          for (var i = 0; i < this.selectedPlans.length; i++) {
            this.subTotal += this.selectedPlans[i].price;
          }
          this.calculateFee(this.total);
          card.addEventListener('change', function(event) {
          var displayError = document.getElementById('card-errors');
          if (event.error) {
            displayError.textContent = event.error.message;
          } else {
            displayError.textContent = '';
          }
        });
        this.cardObject = card;

    },
    selectPlan: function(plan){
      console.log(plan)
      this.addOnPlans = [this.plans[plan]];

      console.log(plan);
      for (var i = 0; i < this.plans.length; i++) {
        if(plan!=i) this.plans[i].selected = 0;
      }
      this.plans[plan].selected = !this.plans[plan].selected;
        this.calculateTotal();
    },
     calculateTotal: function(){
      this.subTotal = 0;
      for (var i = 0; i < this.addOnPlans.length; i++) {
        if(this.addOnPlans[i].selected==true) {
          console.log('ADDING TO TOTAL')
          this.subTotal+= this.addOnPlans[i].price;
        }
      }
      console.log('calculateTotal', this.total);
      this.calculateFee(this.total);
    },
    calculateFee: function(amount){
      if(!this.subTotal){
        this.fee = 0;
        this.subTotal = 0;
        return
      }
      this.fee =  (this.subTotal+0.3)/(1-0.029)- this.subTotal;
      this.total = this.subTotal + this.fee;
      this.fee = this.fee.toFixed(2);
      this.total = this.total.toFixed(2);
    },
    expandBasic:function(evt){
      console.log(evt);
      this.basicVisible =!this.basicVisible;
      console.log('EXPANDED');
    },
    expandAdvanced:function(){
      this.advancedVisible =!this.advancedVisible;
      console.log('EXPANDED Andvanced');
    },
    expandOneOnOne:function(){
      this.oneVisible =!this.oneVisible;
      console.log('EXPANDED 1-1');
    },
    goToSignup:function(){
      this.$router.push('/signup/plan');
    }
  }
}
</script>

<style>
.addons-container{
  background-color: #FFF;
  width: 100%;
  display: inline-block;
  margin-bottom: 30px;    
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}
.addons-container .el-card{
  margin-bottom: 15px;
  position: relative;
      border: 1px solid #EEE;
    border-radius: 4px;
}
.addons-container .el-card.default {
  margin-top: 20px;
  border-color: #042144;
  background-color: #042144;
  color: #FFF;
}

.addons-container .el-card.default .el-card__body{
  padding: 15px;
  color: #FFF;
  text-align: left;
  font-weight: bold;
}


.addons-container .el-card.default .el-card__body p{
  color: #FFF;
  opacity: 0.8;
  font-weight: normal;
}

.addons-container .el-card.default span {
  color: #FFF;
}

.addons-container .el-card__body{
  font-weight: bold;
  padding: 15px;
  color: #666;
  text-align: left;
}
.addons-container .el-card__body a {
  color: #e14a4a;
}

.addons-container .el-card.selectable .el-card__body{
  padding: 15px 15px 15px 40px;
  cursor: pointer;
}

.addons-container .el-card__body p{
  margin: 5px 0 0;
  font-weight: normal;
  font-size: 12px; 
  color: #999;
  
}
.addons-container .el-card__body ul {
  padding-left: 20px;
}
.addons-container .el-card__body p.expandable {
  text-decoration: underline;
}
.addons-container .el-card__body p.expandable:hover{
  color: #666;
}
.addons-container .el-card span{
  position: absolute;
  top:10px;
  right:20px;
  font-weight: bold;
  font-size: 26px;
  color: #999;
}

.addons-container .order-review{
  border:0!important;
}

.addons-container .el-card span.original-price{
  right:20px;
  top:40px;
  color: #CCC;
  font-weight: normal;
  font-size: 12px;
}
.addons-container .el-card span.original-price div{
  display: inline-block;
  color: #e14a4a;
  text-decoration: line-through;
}

.addons-container .el-card .indicator {
  position: absolute;
  left:12px;
  top:24px;
  width: 16px;
  height: 16px;
  border-radius: 20px;
  border:1px solid #EEE;
  background-color: #FAFAFA;
}
.addons-container .el-card .indicator.active{
  background-color: #ef559a;
}
.total-container h3{
  margin: 0;
  text-align: left;
  line-height: 40px;
  color: #666;
}
.next-container{
  text-align: right;
}

.addon-checkout h3{
  margin:0;
  font-family:prohibition;
}
.addon-checkout {
  max-width:500px;
  min-width:400px;
 margin:0 auto;
}
.addon-checkout h3{
  margin:0;
  font-family:prohibition;
  color:#666;
}
.addon-checkout p{
  margin-bottom:5px;
}
.addon-checkout .add-on-payment-container{
  padding:10px;
  border:1px solid #EEE;
}
.addon-checkout p{
  text-align:right;
}
</style>
